import React from 'react'
import {Col, Input, Row} from "antd";
import GithubOutlined from "@ant-design/icons/es/icons/GithubOutlined";
import AppButton from "../../components/button";
import {Link} from "react-router-dom";



const CreateProposal = ({
    ...props
})=>{

    return(
        <div className={'container'}>
            <h1>
                NEW GAME PROPOSAL
            </h1>
            <Row>
                <Col span={8}>
                    <label>Game Title</label>
                    <Input placeholder={'Enter your game title'} className={'margin-sm-y'} />

                </Col>
                <Col span={8} offset={2}>
                    <label>Game Type</label>
                    <Input placeholder={'Game type'} className={'margin-sm-y'} />

                </Col>
            </Row>
            <br/>
            <Row>
                <Col span={8}>
                    <label>Description</label>
                    <Input.TextArea rows={6} placeholder={'Enter your game description'} className={'margin-sm-y'}

                    />

                </Col>
                <Col span={8} offset={2}>
                    <label>Expected Completion Date</label>
                    <Input type={'date'} placeholder={'Game type'} className={'margin-sm-y'} />

                    <br/>
                    <br/>
                            <label>Developer Github handles</label>
                            <Input prefix={<GithubOutlined />} placeholder={'Enter Github username'} className={'margin-sm-y'} />
                    </Col>

            </Row>
            <br/>
            <br/>
            <Row justify={'end'}>
                <Col>

                        <AppButton glow
                        to={'/projects'}
                        >
                            SUBMIT PROPOSAL
                        </AppButton>

                </Col>
            </Row>
        </div>
    )
}

export default CreateProposal